import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import './CadastrarScreen.css';

import Auth from '../../services/Auth';
import Carregando from '../../components/Carregando';
import validarEmail from '../../utils/validarEmail';

import Campeonato from '../../services/Campeonato';

import * as ROUTES from '../../constants/routes';

export default class CadastrarScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: false,
      loading: true,
      erro: false,
      erroMsg: '',
      email: '',
      senha: '',
      repetirSenha: '',
    };
    this.cadastrar = this.cadastrar.bind(this);
  }

  componentDidMount() {
    this.inicializar();
  }

  async inicializar() {
    const admin = await Campeonato.isAdministrador();
    this.setState({ loading: false, admin });
  }

  async cadastrar() {
    const { email, senha, repetirSenha } = this.state;

    this.setState({ loading: true, erro: false });
    try {
      if (!email || email.length < 1) {
        const e = { msg: 'Informe o email para continuar.' };
        throw e;
      }
      if (!validarEmail(email)) {
        const e = { msg: 'Informe um email válido para continuar.' };
        throw e;
      }
      if (!senha || senha.length < 6) {
        const e = { msg: 'Informe uma senha com no mínimo 6 caracteres.' };
        throw e;
      }
      if (senha !== repetirSenha) {
        const e = { msg: 'Senhas não conferem.' };
        throw e;
      }
      const cadastrado = await Auth.cadastrarComEmail(email, senha, repetirSenha);
      let msg;
      if (cadastrado) {
        msg = 'Usuário cadastrado com sucesso.';
      } else {
        msg = 'Houve um erro no cadastro do usuário.';
      }
      this.setState({ loading: false, erro: true, erroMsg: msg });
    } catch (e) {
      this.setState({ loading: false, erro: true, erroMsg: e.msg });
    }
  }

  render() {
    const { admin, loading, erro, erroMsg, email, senha, repetirSenha } = this.state;

    if (loading) {
      return <Carregando />;
    }

    if (!admin) {
      return <Redirect to={ROUTES.SELECAO} />;
    }

    return (
      <div className="Cadastrar">
        <header className="Cadastrar-header">
          <fieldset className="Cadastrar-fieldset">
            <legend>Cadastrar Usuário</legend>
            <div className="Cadastrar-Container">
              <input
                className="Cadastrar-Input"
                type="text"
                placeholder="E-mail"
                value={email}
                onChange={event => this.setState({ email: event.target.value })}
              />
              <input
                className="Cadastrar-Input"
                type="password"
                placeholder="Senha"
                value={senha}
                onChange={event => this.setState({ senha: event.target.value })}
              />
              <input
                className="Cadastrar-Input"
                type="password"
                placeholder="Repetir a Senha"
                value={repetirSenha}
                onSubmit={() => this.cadastrar()}
                onChange={event => this.setState({ repetirSenha: event.target.value })}
              />
              <button type="submit" onClick={() => this.cadastrar()}>
                Cadastrar
              </button>
              <Link to={ROUTES.SELECAO} replace>
                Voltar
              </Link>
            </div>
          </fieldset>
          {erro ? <p>{erroMsg}</p> : null}
        </header>
      </div>
    );
  }
}
